import React from 'react'

import { PriceString } from '@fourthwall/components'

import type { GiftCard } from '../../GiftCards.types'
import { isGiftCardGroup } from '../../utils/isGiftCardGroup'
import * as S from '../GiftCardTableCell/GiftCardTableCell.styled'

type GiftCardUsageTableCellProps = {
  giftCard: GiftCard
}

export const GiftCardUsageTableCell = ({ giftCard }: GiftCardUsageTableCellProps) => {
  return (
    <div>
      <S.Title>
        <PriceString {...giftCard.currentAmount} /> /{' '}
        <S.SecondaryTitle>
          <PriceString {...giftCard.initialAmount} />
        </S.SecondaryTitle>
      </S.Title>
      {isGiftCardGroup(giftCard) && (
        <S.Summary>
          {giftCard.fullyUsedCardsCount} of {giftCard.codes.length} used
        </S.Summary>
      )}
    </div>
  )
}
